@if (design4) {
  <ng-container [ngTemplateOutlet]="DESIGN_4"></ng-container>
} @else {
  <ng-container [ngTemplateOutlet]="DESIGN_2"></ng-container>
}
<ng-template #DESIGN_2>
  <mat-form-field appearance="outline" fxFlex class="pick-us-state" fxFlex="100">
    <mat-label>State</mat-label>

    <mat-select
      matInput
      [formControl]="stateControl"
      (selectionChange)="stateSelected()"
      (openedChange)="focusFilter(filterInput, $event)"
      panelClass="pick-us-state"
      disableOptionCentering="true"
      [required]="required"
    >
      <input
        type="text"
        placeholder="Search..."
        matInput
        class="picker-filter"
        autocomplete="off"
        name="us-state-picker-filter"
        #filterInput
        [formControl]="stateFilterControl"
        (keydown.space)="$event.stopPropagation()"
      />

      @for (option of filteredOptions | async; track option) {
        <mat-option [value]="option">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
    @if (!required && stateControl.value) {
      <mat-icon matSuffix (click)="clear($event)">close</mat-icon>
    }
  </mat-form-field>
</ng-template>

<ng-template #DESIGN_4>
  <div fxLayout="column" fxFlex class="form-row pick-us-state" fxFlex="100">
    <mat-label>State*</mat-label>
    <mat-icon class="chevron-icon">expand_more</mat-icon>

    <mat-select
      matInput
      [formControl]="stateControl"
      (selectionChange)="stateSelected()"
      (openedChange)="focusFilter(filterInput, $event)"
      panelClass="pick-us-state"
      disableOptionCentering="true"
      [required]="required"
    >
      <mat-select-trigger>
        <span>{{ stateControl.value?.name }}</span>
      </mat-select-trigger>

      <input
        type="text"
        placeholder="Search..."
        matInput
        class="picker-filter"
        autocomplete="off"
        name="us-state-picker-filter"
        #filterInput
        [formControl]="stateFilterControl"
        (keydown.space)="$event.stopPropagation()"
      />

      @for (option of filteredOptions | async; track option) {
        <mat-option [value]="option">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
    @if (!required && stateControl.value) {
      <mat-icon matSuffix (click)="clear($event)">close</mat-icon>
    }
  </div>
</ng-template>
